module.exports = __webpack_public_path__ + "img/4.86ce645b.jpg";